module.exports = __webpack_public_path__ + "static/media/02_atw_weihnachtskarte.66ae3227.svg";